import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, Badge, Row, Col, Dropdown, Divider } from "antd";
import { Notification } from "react-iconly";
import {
  getNotificationList,
  updatePushNoptifications,
} from "../../../redux/Notification/NotificationActions";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

export default function HeaderNotifications() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [showAll, setShowAll] = useState(false);

  const direction = useSelector((state) => state.customise.direction);
  const notifications = useSelector(
    (state) => state.notification.notificationList
  );

  useEffect(() => {
    getNotificationList(dispatch);
  }, [dispatch]);

  const sortedNotifications = [...notifications].sort((a, b) => b.Id - a.Id);

  const visibleNotifications = showAll
    ? sortedNotifications
    : sortedNotifications.slice(0, 10);

  const handleNotificationClick = async (notification) => {
    if (notification.IsWebRead === "N") {
      try {
        await updatePushNoptifications(notification.Id, {
          IsMobileRead: "N",
          IsWebRead: "Y",
        });
        getNotificationList(dispatch);
      } catch (error) {
        console.error("Failed to update notification:", error);
      }
    }

    if (notification.ScreenPath) {
      history.push(notification.ScreenPath);
    }
  };

  const notificationMenu = (
    <div
      style={{ width: 350 }}
      className="hp-border-radius hp-border-1 hp-border-color-black-40 hp-bg-black-0 hp-bg-dark-100 hp-border-color-dark-80 hp-pt-24 hp-pb-18 hp-px-18 hp-mt-18"
    >
      <Row align="middle" justify="space-between" className="hp-mb-18">
        <Col className="h5 hp-text-color-black-100 hp-text-color-dark-10 hp-text-color-dark-0 hp-mr-64">
          Notifications
        </Col>

        <Col className="hp-bg-color-primary-1 hp-border-radius-full hp-badge-text hp-text-color-black-0 hp-py-4 hp-px-6 hp-ml-24">
          {notifications.filter((n) => n.IsWebRead === "N").length}
        </Col>
      </Row>

      <Divider className="hp-my-4" />

      <div
        className="hp-overflow-y-auto hp-px-10"
        style={{ maxHeight: 300, marginRight: -10, marginLeft: -10 }}
      >
        {visibleNotifications.map((notification) => {
          const isUnread = notification.IsWebRead === "N";

          return (
            <div key={notification.Id}>
              <Row
                align="middle"
                className="hp-cursor-pointer hp-border-radius hp-transition hp-hover-bg-primary-4 hp-hover-bg-dark-80 hp-py-8 hp-px-10"
                onClick={() => handleNotificationClick(notification)}
              >
                <Col>
                  <p
                    className={`hp-d-block hp-w-100 hp-mb-4 hp-p1-body ${
                      isUnread
                        ? "hp-font-weight-700"
                        : "hp-font-weight-400 hp-text-color-black-80"
                    }`}
                  >
                    {notification.Title}
                  </p>

                  <p
                    className={`hp-d-block hp-badge-text ${
                      isUnread ? "hp-font-weight-600" : "hp-font-weight-400"
                    } hp-text-color-black-60 hp-text-color-dark-40`}
                  >
                    {notification.Message}
                  </p>

                  {notification.createdDate && (
                    <p className="hp-d-block hp-caption hp-text-color-black-80 hp-text-color-dark-50 hp-mt-4">
                      {new Date(notification.createdDate).toLocaleString()}
                    </p>
                  )}
                </Col>
              </Row>
              <Divider style={{ margin: "8px 0" }} />
            </div>
          );
        })}
      </div>

      <Divider className="hp-my-4" />

      {!showAll && notifications.length > 10 && (
        <Link to="/notification">
          <Button
            block
            ghost
            onClick={() => setShowAll(true)}
            className="hp-text-color-primary-1 hp-hover-bg-primary-4 hp-hover-bg-dark-80 hp-mt-4"
          >
            Load More
          </Button>
        </Link>
      )}
    </div>
  );

  return (
    <Col className="hp-d-flex-center">
      <Button
        type="text"
        icon={
          <Dropdown overlay={notificationMenu} placement="bottomRight">
            <div className="hp-position-relative">
              <div
                className="hp-position-absolute"
                style={
                  direction === "rtl"
                    ? { left: -5, top: -5 }
                    : { right: -5, top: -5 }
                }
              >
                <Badge dot status="processing" />
              </div>

              <Notification
                set="curved"
                className="hp-text-color-black-80 hp-text-color-dark-30"
              />
            </div>
          </Dropdown>
        }
      />
    </Col>
  );
}
